import React, { PureComponent } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { userRoutes, tabRoutes } from 'routes';

import Users from './Users';
import UserPage from './UserPage/UserPage';


class UsersRouting extends PureComponent {
  render() {
    return (
      <Switch>
        <Route path={userRoutes.user} component={UserPage} />
        <Route path={tabRoutes.users} component={Users} />
        <Redirect to={tabRoutes.users} />
      </Switch>
    );
  }
}

export default UsersRouting;



// WEBPACK FOOTER //
// ./src/Root/pages/Users/index.js